module.exports = __webpack_public_path__ + "img/chart.bf3f6c7a.png";